module.exports = {
  Banner: require('advocate/components/influnet_promotion/banner'),
  OpenApp: require('advocate/components/influnet_promotion/open_app')
}



// WEBPACK FOOTER //
// ./src/advocate/components/influnet_promotion/index.jsx